import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
function OrderStatus({
  orderItems,
  handleQuantityChange,
  handleDeleteItem,
  handleConfirmOrder,
  isSubmitting,
}) {
  console.log("orderItemsssssss", orderItems);
  return (
    <div className="OrderStatusContainer">
      <h2>Hold Orders</h2>
      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {orderItems.length === 0 ? (
            <tr>
              <td colSpan="4">No items in the order.</td>
            </tr>
          ) : (
            orderItems.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.price}</td>
                <td className="Quantity">
                  <button onClick={() => handleQuantityChange(item.id, false)}>
                    -
                  </button>
                  {item.quantity}
                  <button onClick={() => handleQuantityChange(item.id, true)}>
                    +
                  </button>
                </td>
                <td className="delete">
                  <button onClick={() => handleDeleteItem(item.id)}>
                    <DeleteIcon />
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {orderItems.length > 0 && (
        <button onClick={handleConfirmOrder} disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Confirm Order"}
        </button>
      )}
    </div>
  );
}

export default OrderStatus;
